/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { ModuleGetResponse } from './model/moduleGetResponse';

export const apiProviderProfileModuleRetrieve = (moduleSlug: string, signal?: AbortSignal) => {
  return HTTP<ModuleGetResponse>({
    url: `/api/v7/provider-profile/module/${moduleSlug}/`,
    method: 'GET',
    signal,
  });
};

export const getApiProviderProfileModuleRetrieveQueryKey = (moduleSlug?: string) => {
  return [`/api/v7/provider-profile/module/${moduleSlug}/`] as const;
};

export const getApiProviderProfileModuleRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiProviderProfileModuleRetrieve>>,
  TError = ErrorType<unknown>
>(
  moduleSlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiProviderProfileModuleRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiProviderProfileModuleRetrieveQueryKey(moduleSlug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiProviderProfileModuleRetrieve>>> = ({
    signal,
  }) => apiProviderProfileModuleRetrieve(moduleSlug, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!moduleSlug,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiProviderProfileModuleRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiProviderProfileModuleRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiProviderProfileModuleRetrieve>>
>;
export type ApiProviderProfileModuleRetrieveQueryError = ErrorType<unknown>;

export function useApiProviderProfileModuleRetrieve<
  TData = Awaited<ReturnType<typeof apiProviderProfileModuleRetrieve>>,
  TError = ErrorType<unknown>
>(
  moduleSlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiProviderProfileModuleRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiProviderProfileModuleRetrieveQueryOptions(moduleSlug, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
